import fp from 'lodash/fp';

import { lookupTableReducer } from 'Modules/core/redux';

import { cryptoprofilesActions } from './actions';


const defaultState = {
    initCount: 0,
    profiles: [],
};

const actionLookup = {
    [cryptoprofilesActions.init]: (_, profiles) => ({
        initCount: fp.size(profiles),
        profiles,
    }),
    [cryptoprofilesActions.load]: (state, profiles) => ({
        ...state,
        profiles,
    }),
};

export const reducer = lookupTableReducer(defaultState, actionLookup);
